
import { useAccumulations } from "@/services";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "PrintAccumulations",
  setup() {
    const accumulations = computed(() =>
      Object.values(
        useAccumulations().accumulations.reduce((acc, item) => {
          (acc[item.buffer] = acc[item.buffer] || []).push(item);
          return acc;
        }, {})
      ).sort((a: any, b: any) => a[0].buffer - b[0].buffer)
    );

    return {
      accumulations,
    };
  },
});
